import { render, staticRenderFns } from "./senderProfileForm.vue?vue&type=template&id=6e297e2e&scoped=true"
import script from "./senderProfileForm.vue?vue&type=script&lang=js"
export * from "./senderProfileForm.vue?vue&type=script&lang=js"
import style0 from "./senderProfileForm.vue?vue&type=style&index=0&id=6e297e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e297e2e",
  null
  
)

export default component.exports